﻿import React, {
    forwardRef,
    useImperativeHandle,
    useState
} from 'react';

import { NewUserForm } from 'components/NewUserForm/NewUserForm';
import { PartnerPermissions } from 'pages/partners/types';
import { type UserPermissions } from 'pages/users';
import { FormattedMessage } from 'react-intl';
import { NewUser, User } from 'apis/UsersApi';
import { Modal } from 'react-bootstrap';

export interface UserCreateDialogHandle {
    hide: () => void;
    show: () => void;
}

interface UserCreateDialogProps {
    customCreateClick?: (newPartnerUserObj: NewUser, permissionsCSV: string, existingUser: boolean, allowUserToSetPassword: boolean) => Promise<void>
    page: 'Partner' | 'User';
    permissions: UserPermissions | PartnerPermissions;
    setUsers: React.Dispatch<React.SetStateAction<User[]>>;
    specificPartner?: number;
}

const UserCreateDialog = forwardRef<UserCreateDialogHandle, UserCreateDialogProps>(
    ({ customCreateClick, page, permissions, setUsers, specificPartner }, ref) => {

        const [showModal, setShowModal] = useState(false);
        const [isExistingUser, setIsExistingUser] = useState(false);

        useImperativeHandle(ref, () => ({
            hide: () => {

                setShowModal(false);
                setIsExistingUser(false);

            },
            show: () => {

                setIsExistingUser(false);
                setShowModal(true);

            }
        }));

        const handleCancel = () => {

            setShowModal(false);
            setIsExistingUser(false);

        };

        return (
            <Modal onHide={handleCancel} show={showModal} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {isExistingUser
                            ? <FormattedMessage defaultMessage="Add User" id="add_user.daaf2592" />
                            : <FormattedMessage defaultMessage="New Administrator" id="new_administrator.ba99468a" />}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <NewUserForm
                        customCreateClick={customCreateClick}
                        onExistingUserChange={setIsExistingUser}
                        page={'Partner'}
                        parentCancel={handleCancel}
                        permissions={permissions}
                        setUsers={setUsers}
                        specificPartner={specificPartner}
                    />
                </Modal.Body>
            </Modal>
        );

    }
);

UserCreateDialog.displayName = 'UserCreateDialog';

export default UserCreateDialog;
